import {useCallback, useState} from 'react';

import {useGetRefundBeneficiariesQuery} from '../queries/useGetRefundBeneficiariesQuery';

export function useGetBeneficiaries() {
	const [open, setOpen] = useState(false);
	const [fetchError, setFetchError] = useState(false);
	const {data: options, refetch, isLoading} = useGetRefundBeneficiariesQuery({enabled: false});

	const loadingList = open && isLoading;

	const handleOpen = useCallback(async () => {
		setOpen(true);
		if (!options) {
			const response = await refetch();
			if (response.isError) {
				setFetchError(true);
			}
		}
	}, [options]);

	const handleClose = useCallback(async () => {
		setOpen(false);
	}, []);

	const handleRefresh = useCallback(async () => {
		setFetchError(false);
	}, []);

	return {
		loadingList,
		options,
		open,
		handleOpen,
		handleClose,
		fetchError,
		setFetchError,
		handleRefresh,
	};
}
